import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, Loader2 } from "lucide-react";
import { NGX_LOGO } from "@/lib/brand";

export default function Login() {
  const { login, error } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("cbbarretosantos94@gmail.com");
  const [password, setPassword] = useState("ngxadmin123");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await login(email, password);
    setBusy(false);
    if (ok) navigate("/");
  };

  return (
    <div className="min-h-screen flex bg-[#050B14] text-slate-100">
      {/* Left brand panel */}
      <div className="hidden lg:flex flex-col justify-between w-1/2 border-r border-slate-800 p-12 relative overflow-hidden">
        <div className="absolute inset-0 ngx-grid-overlay opacity-40" />
        <div className="relative z-10">
          <img src={NGX_LOGO} alt="NGX Human Control Station" className="h-32 w-auto object-contain -ml-2" />
        </div>
        <div className="relative z-10 max-w-md">
          <h1 className="font-display text-4xl font-bold leading-tight tracking-tight">
            Human judgment where autonomy needs it.
          </h1>
          <p className="mt-4 text-slate-400 text-base leading-relaxed">
            A vendor-agnostic human supervision and decision layer for intelligent industrial systems.
          </p>
          <div className="mt-8 flex items-center gap-2 text-xs font-mono uppercase tracking-widest text-amber-400">
            <span className="h-2 w-2 rounded-full bg-amber-500 ngx-pulse" /> Simulation Mode
          </div>
        </div>
        <div className="relative z-10 text-xs uppercase tracking-widest text-slate-500">
          BSGOTECH · Industrial Innovation
        </div>
      </div>

      {/* Right form */}
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-sm">
          <div className="lg:hidden mb-8">
            <img src={NGX_LOGO} alt="NGX Human Control Station" className="h-16 w-auto object-contain" />
          </div>
          <div className="flex items-center gap-2 mb-6 text-emerald-400 text-xs font-semibold uppercase tracking-wider">
            <ShieldCheck className="h-4 w-4" /> Operator Authentication
          </div>
          <h2 className="font-display text-2xl font-bold mb-1">Sign in</h2>
          <p className="text-sm text-slate-400 mb-6">Access the NGX Human Control Station.</p>

          <form onSubmit={submit} className="space-y-4" data-testid="login-form">
            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-400">Operator Email</Label>
              <Input
                data-testid="login-email"
                type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 h-12 bg-[#0A1128] border-slate-700 font-mono text-slate-100 focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
            <div>
              <Label className="text-xs uppercase tracking-wider text-slate-400">Password</Label>
              <Input
                data-testid="login-password"
                type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                className="mt-1.5 h-12 bg-[#0A1128] border-slate-700 font-mono text-slate-100 focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
            {error && (
              <p className="text-sm text-red-400 font-mono" data-testid="login-error">{error}</p>
            )}
            <Button
              type="submit" disabled={busy} data-testid="login-submit"
              className="w-full h-12 bg-blue-600 hover:bg-blue-700 text-white font-medium"
            >
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Enter Control Station"}
            </Button>
          </form>
          <p className="mt-6 text-xs text-slate-500 font-mono">
            Demo operator: cbbarretosantos94@gmail.com · ngxadmin123
          </p>
        </div>
      </div>
    </div>
  );
}
